import React from "react";
import styled from "styled-components/macro";
import T from "prop-types";

const InputStyled = styled.input`
  visibility: hidden;
  pointer-events: none;
  position: absolute;
  left: -99999px;
`;

function Honeypot({ value, onChange }) {
  return (
    <InputStyled
      id="input-company"
      name="company"
      type="text"
      placeholder="Company Inc."
      autoComplete="false"
      aria-hidden="true"
      tabIndex={-1}
      value={value}
      onChange={e => onChange(e.target.value)}
    />
  );
}

Honeypot.propTypes = {
  value: T.string,
  onChange: T.func,
};

export default Honeypot;
